import { AbstractControl, Validators } from '@angular/forms';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { hasValue, isNumber } from '@util';
import { minLength as ngrxMinLength } from 'ngrx-forms/validation';

const defaultMessage = 'general.message.minLength';

export const minLengthValidator = (length: number, message: string = defaultMessage) =>
  (control: AbstractControl): PcsValidationErrors => {
    if (Validators.minLength(length)(control)) {
      return createValidationError('minLength', message, [String(length)]);
    }
  };

export const minLength: any = (length: number) => (val: any): any => {
  const value =  isNumber(val) ? val.toString() : val;
  const errors = ngrxMinLength(length)(value);
  return hasValue(errors) ? createValidationError('minLength', defaultMessage, [String(length)]) : null;
};
